module.exports = __webpack_public_path__ + "img/minus.949c8d89.svg";